import React from "react";
import { Paper, Stack, Typography, Button } from "@mui/material";

export default function EmptyState({
  title = "Nada por aqui",
  subtitle = "Sem itens para exibir no momento.",
  actionLabel,
  onAction,
}) {
  return (
    <Paper sx={{ p: 3, borderRadius: 1, textAlign: "center" }}>
      <Stack spacing={1.2} alignItems="center">
        <Typography variant="h6" sx={{ fontWeight: 900 }}>
          {title}
        </Typography>
        <Typography sx={{ color: "text.secondary" }}>{subtitle}</Typography>
        {actionLabel ? (
          <Button variant="contained" onClick={onAction}>
            {actionLabel}
          </Button>
        ) : null}
      </Stack>
    </Paper>
  );
}
